export default __webpack_public_path__ + "static/media/right_chevron.338ad81f.png";